/* RRTC — reproduce el vídeo de una tarjeta de producto al pasar el ratón.
   El <video> lleva preload="none", así que el archivo sólo se descarga en el
   primer hover real. Al salir se pausa y se rebobina, para que la próxima vez
   empiece desde el principio. */
(function () {
  'use strict';

  var FINE = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!FINE || REDUCED) return;

  function bind(video) {
    if (video.__hvReady) return;
    video.__hvReady = true;
    video.muted = true;
    video.setAttribute('muted', '');

    var card = video.closest('.card-wrapper') || video.closest('.card') || video.parentNode;
    if (!card) return;

    function start() {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
    function stop() {
      video.pause();
      try { video.currentTime = 0; } catch (e) {}
    }

    card.addEventListener('mouseenter', start);
    card.addEventListener('mouseleave', stop);
    card.addEventListener('focusin', start);
    card.addEventListener('focusout', stop);
  }

  function scan() {
    document.querySelectorAll('video[data-card-hover-video]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // Las colecciones repintan la rejilla al filtrar o paginar.
  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(function () {
    clearTimeout(scan._t);
    scan._t = setTimeout(scan, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
